export default __webpack_public_path__ + "static/Invoices-ad7edfd975a7591160a1c103ca1244d2.mp4";